<template>
<div class="foot-wrapper">
  <div class="tabel-footer">
    <div class="footer-left">
      <Checkbox
        v-show="isShowAllCheck"
        name="allCheckBox"
        class="all-check"
        :data="allCheck"
        @valueChange="allCheckHandler"
      />
      <label
        v-show="isShowAllCheck"
        class="all-label"
        for="allCheckBox"
      >
        {{ allLabel }}
        <span
          v-if="isTotal"
          class="total-number"
        >共计<i>{{ total }}</i>条</span>
        <span v-if="showCheckedNum" class="checked-number">已选择<i> {{ checkedRows.length }} </i>条</span>
      </label>
      <div class="all-buttons">
        <component
          :is="btn.type || 'Button'"
          v-for="(btn, idx) in buttons"
          :id="btn.id"
          :key="idx"
          class="btn"
          :text="btn.text"
          :icon="btn.icon"
          :right-icon="btn.rightIcon"
          :add-data="btn"
          :hover-icon="btn.hoverIcon"
          :hover-icon-right="btn.hoverIconRight"
          :options="btn.options"
          :get-options="btn.getOptions"
          @btnClick="btnClick($event, btn)"
        />
      </div>
    </div>
    <div
      class="page-rank"
      :class="{'page-rank-margin': buttons.length}"
    >
      <PageLengthSelect
        v-show="isShowLengthSelect"
        :page-rank="config.pageLengthRank"
        :cur-length="pageLength"
        @lengthChange="lengthChange"
      />
    </div>
  </div>
  <div class="page-control">
    <PageControl
      :total="total"
      :cur-page="curPage"
      :length-rank="config.pageLengthRank"
      :page-length="pageLength"
      @pageChange="pageChange"
    />
  </div>
</div>
</template>

<script>
import Checkbox from '@/views/zhiji/bComponents/checks/Checkbox.vue';
import Button from '@/views/zhiji/bComponents/buttons/Button.vue';
import OptionButton from '@/views/zhiji/bComponents/buttons/OptionButton.vue';
// import SelectButton from '@/views/zhiji/bComponents/buttons/SelectButton.vue';
import PageControl from '@/views/zhiji/bComponents/pageController/PageControl.vue';
import PageLengthSelect from '@/views/zhiji/bComponents/pageController/PageLengthSelect.vue';

/**
 * emit checkAll, emit btnClick, emit pageChange
 */
export default {
  name: 'Footer',
  components: {
    Checkbox,
    Button,
    OptionButton,
    PageControl,
    PageLengthSelect,
    // SelectButton,
  },
  props: ['config', 'total', 'curPage', 'allCheck', 'isTotal', 'showCheckedNum', 'checkedRows' ],
  data () {
    return {
      allLabel: '当页全选',
      pageLength: this.config.pageLength || 10,
    };
  },
  computed: {
    buttons () {
      return this.config.bottomButtons || [];
    },
    isShowAllCheck () {
      return this.config.columns[0].type === 'Checkbox';
    },
    isShowLengthSelect () {
      return !this.config.isHidePageLengthSelect;
    },
  },
  methods: {
    btnClick (event, data) {
      this.$emit('btnClick', { originEvent: event, data });
    },
    lengthChange (pageLen) {
      this.pageChange({
        pageLength: pageLen,
        curPage: this.curPage,
      });
      this.pageLength = pageLen;
    },
    pageChange (page) {
      if (page.pageLength === this.pageLength && page.curPage === this.curPage) {
        return;
      }
      this.config.pageChange && this.config.pageChange.call(null, page);
      this.allCheckHandler({
        checked: false,
      });

      this.$emit('pageChange', page);
    },
    allCheckHandler (data) {
      this.$emit('checkAll', data.checked);
    },
  },
};
</script>

<style lang="less" scoped>
.tabel-footer {
    width: 100%;
    background: #f2f7fb;
    padding: 10px 0 10px 20px;
    position: relative;
    color: rgba(65, 71, 94, 0.7);
    border-top: 1px solid #e3ecf5;
    border-bottom: 1px solid #e3ecf5;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .all-check {
        position: relative;
        padding: 0px 15px 0px 0;
        box-sizing: border-box;
        display: inline-block;
        top: 2px;
    }

    .all-label {
        position: relative;
        margin-right: 20px;
    }
    .footer-left {
        width: calc(100%- 120px);
        display: flex;
        align-items: center;
    }
    .all-buttons {
        display: flex;
        align-items: center;
    }

    .page-rank {
        float: right;
        margin: 0 30px 0 0;
    }

    .page-rank-margin {
        margin: 5px 30px 0 0;
    }

    .btn {
        margin-right: 8px;
    }
    .total-number {
        margin-left: 16px;
        &>i {
            color: #00c972;
            font-style: normal;
            font-weight: normal;
        }
    }
    .checked-number {
        margin-left: 16px;
        &>i {
            color: #00c972;
            font-style: normal;
            font-weight: normal;
        }
    }
}

.page-control {
    padding: 20px 0;
    text-align: center;
}
</style>
